import {createStore} from 'vuex'

import user from './modules/user'
import sales from "./modules/sales"
import stock from "./modules/stock"
import config from "./modules/config"
import createPersistedState from "vuex-persistedstate";
import {loadPersistedConfig} from './persistedState'

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user: user,
    sales: sales,
    stock: stock,
    config: config,
  },
  plugins: [
    createPersistedState({
      paths: ['config'],
      getState: loadPersistedConfig,
    })
  ],
})
